import { ColDef } from "ag-grid-enterprise";
import { partTypeCodes } from "../components/TableParts";
import { Part } from "../models/Part";

export const useTableData = () => {
	const columnDefs: ColDef[] = [
		{
			field: "PartName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "LocationName",
			headerName: "Location",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "Sections",
			headerName: "Sections",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "Stands",
			headerName: "Stands",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "PartTypeCode",
			headerName: "Type",
			minWidth: 20,
			flex: 1,
			valueGetter: (params) =>
				partTypeCodes.find(
					(part) => part.Code === (params.data as Part).PartTypeCode,
				)?.Name,
		},
	];
	return { columnDefs };
};
